import * as React from 'react';
import SafeReactPaginate from '../../../General/SafeReactPaginate';
import BigSpinner from '../../../General/BigSpinner';
import './LiquidacionDetalleTabla.css';

export const LIQUIDACION_DETALLE_PAGE_SIZE = 10;

export default class LiquidacionDetalleTabla extends React.Component {
    constructor(props) {
        super(props);
        this.state = { currentPage: 0 };
    }

    static defaultProps = {
        pageSize: LIQUIDACION_DETALLE_PAGE_SIZE,
    };

    componentDidUpdate(prevProps) {
        const prevLen = prevProps.data?.length ?? 0;
        const nextLen = this.props.data?.length ?? 0;
        if (prevLen !== nextLen) {
            this.setState({ currentPage: 0 });
        }
    }

    handlePageClick = ({ selected }) => {
        this.setState({ currentPage: selected });
    };

    getVisibleSlice() {
        const { data = [], pageSize } = this.props;
        const { currentPage } = this.state;
        const total = data.length;
        const pageCount = Math.max(1, Math.ceil(total / pageSize));
        const safePage = Math.min(currentPage, pageCount - 1);
        const startIndex = safePage * pageSize;

        return {
            items: data.slice(startIndex, startIndex + pageSize),
            startIndex,
            total,
            pageCount,
            currentPage: safePage,
        };
    }

    render() {
        const {
            title,
            isLoading,
            loadingMessage,
            emptyMessage,
            tableHead,
            renderRow,
            data = [],
            pageSize,
            headerAction,
        } = this.props;

        if (isLoading) {
            return <BigSpinner message={loadingMessage} />;
        }

        if (!data.length) {
            return (
                <div className="liquidacion-detalle-seccion">
                    <div className="liquidacion-detalle-tabla-card liquidacion-detalle-tabla-card--empty">
                        <div className="liquidacion-detalle-tabla-card__header">
                            <h5 className="liquidacion-detalle-tabla-card__title mb-0">{title}</h5>
                        </div>
                        <div className="liquidacion-detalle-tabla-card__empty">{emptyMessage}</div>
                    </div>
                </div>
            );
        }

        const { items, startIndex, total, pageCount, currentPage } = this.getVisibleSlice();
        const first = startIndex + 1;
        const last = Math.min(startIndex + pageSize, total);
        const showPagination = total > pageSize;

        return (
            <div className="liquidacion-detalle-seccion">
                <div className="liquidacion-detalle-tabla-card">
                    <div className="liquidacion-detalle-tabla-card__header">
                        <h5 className="liquidacion-detalle-tabla-card__title mb-0">{title}</h5>
                        <span className="liquidacion-detalle-tabla-card__badge">
                            {total} registro{total !== 1 ? 's' : ''}
                        </span>
                        {headerAction}
                    </div>
                    <div className="liquidacion-detalle-tabla-card__body">
                        <div className="table-responsive">
                            <table className="table table-hover liquidacion-detalle-tabla mb-0">
                                <thead>{tableHead}</thead>
                                <tbody>
                                    {items.map((item, i) => renderRow(item, i, startIndex + i))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="liquidacion-detalle-tabla-card__footer">
                        <span className="liquidacion-detalle-tabla-card__summary">
                            {showPagination
                                ? `Mostrando ${first}–${last} de ${total}`
                                : `${total} registro${total !== 1 ? 's' : ''}`}
                        </span>
                        {showPagination && (
                            <SafeReactPaginate
                                previousLabel="Anterior"
                                nextLabel="Siguiente"
                                breakLabel="..."
                                breakClassName="break-me"
                                pageCount={pageCount}
                                marginPagesDisplayed={1}
                                pageRangeDisplayed={3}
                                onPageChange={this.handlePageClick}
                                forcePage={currentPage}
                                containerClassName="pagination liquidacion-detalle-pagination mb-0"
                                subContainerClassName="pages pagination"
                                activeClassName="active"
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
